const CHART = {
  width: 600,
  height: 600,
  padding: 80
};

const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

const stableHash = value => String(value || '').split('').reduce((hash, char) => ((hash << 5) - hash + char.charCodeAt(0)) | 0, 0);

const stableJitter = (seed, range) => {
  const normalized = Math.abs(stableHash(seed)) % 1000;
  return ((normalized / 1000) - 0.5) * range;
};

export const getQuadrant = ({ impact = 0, effort = 3 }) => {
  if (impact > 3 && effort <= 3) return { key: 'quickWins', label: 'Quick Wins', color: 'rgb(217 229 5)' };
  if (impact > 3 && effort > 3) return { key: 'strategic', label: 'Strategic Plays', color: 'rgb(28 51 74)' };
  if (impact <= 3 && effort <= 3) return { key: 'fillIns', label: 'Fill-Ins', color: 'rgb(156 163 175)' };
  return { key: 'timeSinks', label: 'Time Sinks', color: 'rgb(107 114 128)' };
};

export const getBubblePosition = (opportunity = {}, dimensions = CHART) => {
  const { width, height, padding } = dimensions;
  const chartWidth = width - 2 * padding;
  const chartHeight = height - 2 * padding;
  const effort = clamp(Number(opportunity.effort) || 1, 1, 5);
  const impact = clamp(Number(opportunity.impact) || 1, 1, 5);
  const seed = `${opportunity.roi_index ?? ''}-${opportunity.name ?? ''}`;
  const xBase = padding + ((effort - 1) / 4) * chartWidth;
  const yBase = padding + ((5 - impact) / 4) * chartHeight;
  const jitterRange = chartWidth * 0.08;

  return {
    cx: Math.round(clamp(xBase + stableJitter(`${seed}-x`, jitterRange), padding + 15, width - padding - 15)),
    cy: Math.round(clamp(yBase + stableJitter(`${seed}-y`, jitterRange), padding + 15, height - padding - 15))
  };
};

export const getBubbleRadius = annual => {
  const value = Number(annual) || 0;
  if (value <= 0) return 10;
  return Math.min(18, Math.max(10, 10 + Math.log10(value / 1000 + 1) * 4));
};
